import { render, staticRenderFns } from "./FormRF04_2.vue?vue&type=template&id=0a4937c3&"
import script from "./FormRF04_2.vue?vue&type=script&lang=js&"
export * from "./FormRF04_2.vue?vue&type=script&lang=js&"
import style0 from "./FormRF04_2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports